module.exports = __webpack_public_path__ + "img/tomas-niborski-byn.2dd3b551.jpg";